import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const BottomNav = () => {
  const navItems = [
    { path: '/home', icon: 'Home', label: 'Home' },
    { path: '/invitations', icon: 'Mail', label: 'Invitations' },
    { path: '/create', icon: 'PlusCircle', label: 'Create', special: true },
    { path: '/moments', icon: 'Image', label: 'Moments' },
    { path: '/profile', icon: 'User', label: 'Profile' }
  ];

  return (
    <div className="absolute bottom-0 w-full glass-nav pb-safe pt-2 px-4 z-50">
      <div className="flex justify-between items-center mb-2">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `
              flex flex-col items-center justify-center w-16
              ${isActive ? 'text-pink-500' : 'text-gray-400 hover:text-gray-600'}
            `}
          >
            {item.special ? (
              <div className="bg-pink-500 text-white rounded-full p-3 -mt-6 shadow-lg shadow-pink-200">
                <SafeIcon name={item.icon} className="text-2xl" />
              </div>
            ) : (
              <>
                <SafeIcon name={item.icon} className="text-xl mb-1" />
                <span className="text-[10px] font-medium">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default BottomNav;